var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassResultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2v4.5A1.5 1.5 0 0 0 11.5 8H16v8.5a1.5 1.5 0 0 1-1.5 1.5H8v-2.355a4 4 0 0 0-4-6.52V3.5A1.5 1.5 0 0 1 5.5 2H10zm1 .25V6.5a.5.5 0 0 0 .5.5h4.25L11 2.25zM8 13a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm-1 3.464A3.982 3.982 0 0 1 5 17a3.982 3.982 0 0 1-2-.535v2.286a.25.25 0 0 0 .378.215L5 17.998l1.622.966A.25.25 0 0 0 7 18.75v-2.286z",
    fill: "#000",
    fillOpacity: 0.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassResultIcon);
export default __webpack_public_path__ + "static/media/class-result-icon.8436ca8b406186b367e6ad94d9fc324b.svg";
export { ForwardRef as ReactComponent };